<template>
  <div class="app-container">
    <div class="app-layout">
      <Header />
      <template v-if="isLoading">
        <BaseLoading class="baseLoading" />
      </template>
      <template v-else-if="error">
        {{ error }}
      </template>
      <template v-else>
        <main>
          <RouterView />
        </main>
      </template>
      <Grid v-if="isHomePage" class="mt-[250px]" />
      <VAlerts />
    </div>
    <Footer :hasFixedBanner="hasFixedBanner" />
  </div>
</template>

<script>
import { Header } from "@/widgets/Header";
import { Footer } from "@/widgets/Footer";
import { Grid } from "@/widgets/base";
import { setLocale } from "@vee-validate/i18n";
import moment from "moment";
import CONFIG from "@/app/config";
import { mapActions } from "vuex";
import { BaseLoading } from "@/shared/ui";
import VAlerts from "@/shared/ui/VAlerts/ui/VAlerts.vue";

// services
import ApiService from "@/shared/services/api.service";

export default {
  name: "Layout",
  components: {
    VAlerts,
    Header,
    BaseLoading,
    Grid,
    Footer,
  },
  data() {
    return {
      isLoading: false,
      error: null,
    };
  },
  computed: {
    isHomePage() {
      //return this.$route.path === "/";
      // Скрыт блок до фикса
      return false;
    },
    hasFixedBanner() {
      return (
        this.$route.path.includes("transaction") ||
        this.$route.path.includes("address")
      );
    },
  },
  methods: {
    ...mapActions("explorer", ["PING", "GET_VERSION"]),
    ...mapActions("coinService", ["GET_RATE_PAIRS", "GET_COINS"]),
  },

  async mounted() {
    try {
      const [pingResponse, versionResponse] = await Promise.allSettled([
        this.PING(),
        this.GET_VERSION(),
        this.GET_RATE_PAIRS(ApiService.ratesApi),
      ]);

      if (
        pingResponse.status === "rejected" ||
        versionResponse.status === "rejected"
      ) {
        // this.error = "Error while fetching data";
        return;
      }
      const { value: ping } = pingResponse;
      const {
        value: { build_date, version },
      } = versionResponse;
      console.table({ ping, build_date, version });
      this.isLoading = false;
    } catch (error) {
      // this.error = error;
    }

    // Init Analytics Service
    window.emcd.AnalyticsService.init();
    // Boot intercom
    setTimeout(() => {
      window.Intercom("boot", {
        app_id: CONFIG.INTERCOM_APP_ID,
        language_override: this.$i18n.locale === "ru" ? "ru" : "en",
      });
    }, 2000);
  },

  watch: {
    "$i18n.locale": {
      immediate: true,
      handler(lang) {
        this.$cookies.set("lang", lang, 60 * 60 * 24 * 30);
        window.emcd.AnalyticsService.setLanguage(lang); // intercom and Sentry
        setLocale(lang); // vee-validate
        moment.locale(lang); // moment.js
      },
    },
    "$route.query.id"(newId) {
      this.selectedObjectId = newId ? Number(newId) : null;
    },
  },
};
</script>

<style lang="scss">
.toast-container {
  button {
    top: 22px !important;
    right: 22px !important;
  }
}

.app-layout {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  height: max-content;
  min-height: 100vh;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;

  @media (max-width: 768px) {
    min-height: 115vh;
  }

  main {
    flex: 1;
    overflow-y: auto;
    max-width: 1200px;
    margin: 76px auto 0;
    width: 100%;

    @media (max-width: 768px) {
      margin-top: 160px;
    }
  }

  @media (width < 1024px) {
    max-width: 768px;
    margin-right: auto;
    margin-left: auto;
  }

  @media (width < 768px) {
    max-width: 576px;
    margin-right: auto;
    margin-left: auto;
  }
}

.baseLoading {
  margin-top: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 400px;
}
</style>
